import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterEntry, getReadableName, Operator } from '@services/core-services/filters';
import { BadgesComponent } from '@enginuity/core/molecules/badges/badges.component';

@Component({
  selector: 'app-filter-operator-label',
  imports: [CommonModule, BadgesComponent],
  templateUrl: './filter-operator-label.component.html',
  styleUrl: './filter-operator-label.component.scss',
})
export class FilterOperatorLabelComponent {
  private _operator: Operator | string | undefined;

  get operator(): Operator | string | undefined {
    return this._operator;
  }

  @Input() rule!: FilterEntry;

  @Input()
  set operator(value: Operator | string | undefined) {
    this._operator = value;
    if (value) {
      this.label = getReadableName(value as Operator);
    }
  }

  public label: string = '';
}
